import wingoChat from '@web/assets/wingo-chat.png'
import { Button } from '@tecsinapse/cortex-react'
import { useKeycloak } from '@web/modules/core'
import { NotificationService } from '@web/notifications/NotificationService'
import React, { useCallback } from 'react'
import { publicityVariants } from '../styles'

const { container, logo, stack, title, description, cta, linkButton } = publicityVariants()

const WINGO_CHAT_URL = 'https://www.tecsinapse.com.br/wingo-chat/'

const Publicity = () => {
  const { instance: kcInstance } = useKeycloak()

  const handleReturnLogin = useCallback(() => {
    NotificationService.endNotificationService().then(() => {
      kcInstance?.logout()
    })
  }, [kcInstance])

  return (
    <div className={container()}>
      <img
        className={logo()}
        src={wingoChat}
        alt='Wingo Chat'
      />
      <div className={stack()}>
        <p className={title()}>Você ainda não tem o Wingo Chat!</p>
        <p className={description()}>
          Clique no botão abaixo para solicitar uma apresentação e contratar a integração ao WhatsApp!
        </p>
        <Button
          className={cta()}
          variants={{ intent: 'primary' }}
          onClick={() => {
            window.open(WINGO_CHAT_URL, '_blank', 'noopener,noreferrer')
          }}
        >
          Conheça o Wingo Chat
        </Button>
        <Button
          variants={{ variant: 'text' }}
          className={linkButton()}
          onClick={handleReturnLogin}
        >
          Retornar à tela de login
        </Button>
      </div>
    </div>
  )
}

export default Publicity
